import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

export default class Expertise {
    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        ScrollMagicPluginGsap(ScrollMagic, gsap);

        this.header();
        this.background();
    }

    header() {
        const elts = document.querySelectorAll('.single-expertise .article .container__background, .single-programme .article .container__background');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                const wrapper = elt.querySelector('.container__wrapper');
                if (wrapper.children[1]) {
                    gsap.to(
                        wrapper.children[1],
                        {
                            scrollTrigger: {
                                trigger: wrapper,
                                start: 'top 80%',
                            },
                            ease: 'none',
                            x: (wrapper.children[1].clientWidth + wrapper.offsetWidth) * -1,
                            duration: 25,
                        }
                    );
                }
            });
        }
    }

    background() {
        const elts = document.querySelectorAll('.single-expertise .article .content__background, .single-programme .article .content__background');
        if (elts.length > 0) {
            elts.forEach((elt, index) => {
                const wrapper = elt.querySelector('.content__wrapper');
                let direction = -1;
                if (index % 2 === 0) {
                    direction = 1;
                }
                if (wrapper.children[1]) {
                    gsap.to(
                        wrapper.children[1],
                        {
                            scrollTrigger: {
                                trigger: wrapper,
                                start: 'top 80%',
                            },
                            ease: 'none',
                            x: (wrapper.children[1].clientWidth + wrapper.offsetWidth) * direction,
                            duration: 25,
                        }
                    );
                }
            });
        }
    }
}